import { render, staticRenderFns } from "./PreviewJobCompanyTopic.vue?vue&type=template&id=5d220cb6&scoped=true"
import script from "./PreviewJobCompanyTopic.vue?vue&type=script&lang=js"
export * from "./PreviewJobCompanyTopic.vue?vue&type=script&lang=js"
import style0 from "./PreviewJobCompanyTopic.vue?vue&type=style&index=0&id=5d220cb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d220cb6",
  null
  
)

export default component.exports